export default __webpack_public_path__ + "static/media/spons-back.955d6619.svg";